module.exports = __webpack_public_path__ + "img/image2019-3-12_17_27_5.7723b82f.png";